import React, { useRef, useEffect, useState } from "react";
import { Props } from "./types";
import { Wrapper } from "./styled-components";
import { renderContent } from "./renderer";

const SHADOW_THRESHOLD = 35;

const Table = ({ data, columns, hasEmptyCorner = false }: Props) => {
  const tableRef = useRef<HTMLDivElement>(null);
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    const handleScrollListener = () => {
      if (tableRef.current) {
        setHasScrolled(tableRef.current.scrollLeft > SHADOW_THRESHOLD);
      }
    };

    tableRef.current?.addEventListener("scroll", handleScrollListener);

    return () => {
      tableRef.current?.removeEventListener("scroll", handleScrollListener);
    };
  }, []);

  return (
    <Wrapper
      ref={tableRef}
      hasScrolled={hasScrolled}
      data-qa-label="probables-table-container"
    >
      {renderContent(columns, data, hasEmptyCorner)}
    </Wrapper>
  );
};

export default Table;
